module.exports = __webpack_public_path__ + "static/media/id-card.fbf7d380.svg";